// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__yFWYc","desabilitar":"OptionSelect_desabilitar__dDlx3","focado":"OptionSelect_focado__9RAdd","novo":"OptionSelect_novo__u8R1t"};